module.exports = __webpack_public_path__ + "assets/img/sdlkj.a167c690.png";